/* eslint-disable */

import BankingServices, { getBankingServices } from './BankingServices';
import UtilityBillsAndEMI from './utilityBillsAndEMI';
import CommonService from './CommonService';
import Reports from './Reports';
import Pancard from './Pancard';
import Wallet from './Wallets';
import dashboard from './dashboard';
import RDServices from './RDServices';
import CustomerSupport from './CustomerSupport';
import HelpLine from './HelpLine';
import MerchantEmployee from './MerchantEmployee';
import Batches from './Batches';
import Ledger from './Ledger';
import BankAccount from './BankAccount';
import Payout from './Payout';

// ==============================|| MENU ITEMS ||============================== //

export const getMerchantMenuItems = () => {
    const currentDomain = window.location.hostname;
    const portalStatus = localStorage.getItem('portalStatus');
    const specialTransfer = localStorage.getItem('specialTransfer');
    const payoutStatus = localStorage.getItem('payout_status');

    // If payout_status is '0', hide all merchant sidemenu and only show Payout -> Add, List
    if (payoutStatus !== null && payoutStatus !== undefined && String(payoutStatus) === '1') {
        return {
            items: [Payout]
        };
    }

    const dynamicBankingServices = typeof getBankingServices === 'function' ? getBankingServices() : BankingServices;

    let menuItems = {
        items: [dashboard, Reports, dynamicBankingServices, CommonService, UtilityBillsAndEMI, Wallet, MerchantEmployee, Batches, Pancard, RDServices]
    };

    if (specialTransfer === 'true') {
        const batchesIndex = menuItems.items.indexOf(UtilityBillsAndEMI);
        if (batchesIndex !== -1) {
            menuItems.items.splice(batchesIndex + 1, 0, BankAccount);
        }
    }

    if (currentDomain === 'app.acemoney.in' || currentDomain === 'dev-app.acemoney.in' || currentDomain === 'localhost') {
        // ACEMONEY SUPPORT NUMBER SECTION NOT ACCESSIBLE FOR WHITELABEL
        menuItems.items.push(HelpLine);
    } else if (portalStatus) {
        menuItems = { items: [dashboard, Ledger, RDServices, Reports] };
        menuItems.items.push(HelpLine);
    } else {
        menuItems.items.push(CustomerSupport);
    }

    return menuItems;
};

const menuItems = getMerchantMenuItems();
export default menuItems;
